import { render, staticRenderFns } from "./ListCase.vue?vue&type=template&id=1881170f&"
import script from "./ListCase.vue?vue&type=script&lang=js&"
export * from "./ListCase.vue?vue&type=script&lang=js&"
import style0 from "./ListCase.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ListCaseItem: require('/home/runner/work/myody_front/myody_front/components/list/ListCaseItem.vue').default})
